import { useEffect, useState } from 'react';
import { CONTACT_ADMIN_CHANGED_EVENT } from '../components/contactAdmin/contactAdmin';
import { fetchSupportTickets } from '../services/api';

export const CONTACT_ADMIN_POLL_MS = 60_000;

/**
 * How many of the Shop's tickets have an admin reply it has not read (sidebar badge on Contact
 * admin). Refreshes on mount, every minute while the tab is visible, on window focus and on
 * `contact-admin-changed`. Errors are ignored: the badge keeps its last value.
 */
export function useContactAdminUnread(enabled = true): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let cancelled = false;

    const refresh = async () => {
      try {
        const res = await fetchSupportTickets({ page: 1, limit: 1 });
        const next = res?.success ? Number(res.data?.pagination?.unreadCount) : NaN;
        if (!cancelled && Number.isFinite(next)) setCount(Math.max(0, Math.floor(next)));
      } catch {
        /* badge only: keep the last value */
      }
    };

    const onEvent = () => {
      void refresh();
    };
    const onTick = () => {
      if (document.visibilityState === 'hidden') return;
      void refresh();
    };

    void refresh();
    const timer = window.setInterval(onTick, CONTACT_ADMIN_POLL_MS);
    window.addEventListener('focus', onEvent);
    window.addEventListener(CONTACT_ADMIN_CHANGED_EVENT, onEvent);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', onEvent);
      window.removeEventListener(CONTACT_ADMIN_CHANGED_EVENT, onEvent);
    };
  }, [enabled]);

  return count;
}
